import { render, staticRenderFns } from "./EliteReview.vue?vue&type=template&id=c679cd84&scoped=true&"
import script from "./EliteReview.vue?vue&type=script&lang=js&"
export * from "./EliteReview.vue?vue&type=script&lang=js&"
import style0 from "./EliteReview.vue?vue&type=style&index=0&id=c679cd84&prod&lang=css&"
import style1 from "./EliteReview.vue?vue&type=style&index=1&id=c679cd84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c679cd84",
  null
  
)

export default component.exports